import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
var bodyBold = typography.bodyBold,
  bodySmallBold = typography.bodySmallBold;
export var inspection = /*#__PURE__*/css("display:flex;margin-bottom:28px;align-items:center;", media('>=tablet'), "{max-width:360px;}");
export var inspectionExpanded = {
  name: "qednh9",
  styles: ":last-of-type{margin-bottom:0;}"
};
export var date = {
  name: "1ylu0bo",
  styles: "display:flex;flex-direction:column;flex-grow:1;"
};
export var day = /*#__PURE__*/css(bodyBold, ";");
export var time = /*#__PURE__*/css("color:", colour.neutral600, ";");
export var calendarButton = {
  name: "12z0wuy",
  styles: "margin-right:8px;"
};
export var plannerButton = /*#__PURE__*/css("width:137px;", bodySmallBold, ";white-space:nowrap;", media('>=tablet'), "{width:153px;}");
export var spinner = {
  name: "15ro776",
  styles: "margin-right:4px;"
};
export var popupContainer = {
  name: "79elbk",
  styles: "position:relative;"
};

// We do not want to be doing this, but it's the best we can do
// Until we create our own standard modal
export var modal = /*#__PURE__*/css("> div{height:100%;", media('>=tablet'), "{width:375px;height:478px;}> div:first-of-type{margin:3px;> button{color:", colour.neutral400, ";float:left;margin:10px 10px 20px 10px;outline:none;}}}");